// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../node_modules/rescript/lib/es6/js_dict.js";

function fs_info_encode(v) {
  return Js_dict.fromArray([
              [
                "fare_type",
                Decco.stringToJson(v.fare_type)
              ],
              [
                "quotation_uuid",
                Decco.stringToJson(v.quotation_uuid)
              ]
            ]);
}

function address_encode(v) {
  return Js_dict.fromArray([
              [
                "title",
                Decco.stringToJson(v.title)
              ],
              [
                "subtitle",
                Decco.stringToJson(v.subtitle)
              ]
            ]);
}

function contact_encode(v) {
  return Js_dict.fromArray([
              [
                "name",
                Decco.stringToJson(v.name)
              ],
              [
                "number",
                Decco.stringToJson(v.number)
              ]
            ]);
}

function address_details_encode(v) {
  return Js_dict.fromArray([
              [
                "locality",
                Decco.optionToJson(Decco.stringToJson, v.locality)
              ],
              [
                "sub_locality",
                Decco.optionToJson(Decco.stringToJson, v.sub_locality)
              ]
            ]);
}

function rebooking_info_encode(v) {
  return Js_dict.fromArray([[
                "parent_order_id",
                Decco.stringToJson(v.parent_order_id)
              ]]);
}

function waypoints_attributes_encode(v) {
  return Js_dict.fromArray([
              [
                "lat",
                Decco.floatToJson(v.lat)
              ],
              [
                "long",
                Decco.floatToJson(v.long)
              ],
              [
                "address",
                address_encode(v.address)
              ],
              [
                "doorstep_address",
                Decco.optionToJson(Decco.stringToJson, v.doorstep_address)
              ],
              [
                "address_components",
                Decco.arrayToJson(Decco.stringToJson, v.address_components)
              ],
              [
                "address_details",
                address_details_encode(v.address_details)
              ],
              [
                "favorite_uuid",
                Decco.optionToJson(Decco.stringToJson, v.favorite_uuid)
              ],
              [
                "contact",
                contact_encode(v.contact)
              ]
            ]);
}

function goods_type_info_encode(v) {
  return Js_dict.fromArray([
              [
                "business_types_id",
                Decco.intToJson(v.business_types_id)
              ],
              [
                "business_type_description",
                Decco.stringToJson(v.business_type_description)
              ],
              [
                "quantity_of_goods",
                Decco.stringToJson(v.quantity_of_goods)
              ]
            ]);
}

function order_encode(v) {
  return Js_dict.fromArray([
              [
                "geo_region_id",
                Decco.intToJson(v.geo_region_id)
              ],
              [
                "vehicle_id",
                Decco.intToJson(v.vehicle_id)
              ],
              [
                "from_address_lat",
                Decco.floatToJson(v.from_address_lat)
              ],
              [
                "from_address_long",
                Decco.floatToJson(v.from_address_long)
              ],
              [
                "from_address_doorstep",
                Decco.optionToJson(Decco.stringToJson, v.from_address_doorstep)
              ],
              [
                "to_address_lat",
                Decco.floatToJson(v.to_address_lat)
              ],
              [
                "to_address_long",
                Decco.floatToJson(v.to_address_long)
              ],
              [
                "to_address_doorstep",
                Decco.optionToJson(Decco.stringToJson, v.to_address_doorstep)
              ],
              [
                "from_address",
                address_encode(v.from_address)
              ],
              [
                "from_address_components",
                Decco.arrayToJson(Decco.stringToJson, v.from_address_components)
              ],
              [
                "to_address",
                address_encode(v.to_address)
              ],
              [
                "to_address_components",
                Decco.arrayToJson(Decco.stringToJson, v.to_address_components)
              ],
              [
                "from_address_details",
                address_details_encode(v.from_address_details)
              ],
              [
                "to_address_details",
                address_details_encode(v.to_address_details)
              ],
              [
                "pickup_favorite_uuid",
                Decco.optionToJson(Decco.stringToJson, v.pickup_favorite_uuid)
              ],
              [
                "drop_off_favorite_uuid",
                Decco.optionToJson(Decco.stringToJson, v.drop_off_favorite_uuid)
              ],
              [
                "coupon_code",
                Decco.optionToJson(Decco.stringToJson, v.coupon_code)
              ],
              [
                "goods_type_info",
                goods_type_info_encode(v.goods_type_info)
              ],
              [
                "pickup_name",
                Decco.stringToJson(v.pickup_name)
              ],
              [
                "pickup_phone_number",
                Decco.stringToJson(v.pickup_phone_number)
              ],
              [
                "payment_mode",
                Decco.stringToJson(v.payment_mode)
              ],
              [
                "use_porter_credits",
                Decco.boolToJson(v.use_porter_credits)
              ],
              [
                "customer_location_lat",
                Decco.optionToJson(Decco.floatToJson, v.customer_location_lat)
              ],
              [
                "customer_location_long",
                Decco.optionToJson(Decco.floatToJson, v.customer_location_long)
              ],
              [
                "try_book_till",
                Decco.boolToJson(v.try_book_till)
              ],
              [
                "pickup_in_mins",
                Decco.intToJson(v.pickup_in_mins)
              ],
              [
                "receiver_name",
                Decco.stringToJson(v.receiver_name)
              ],
              [
                "receiver_mobile_number",
                Decco.stringToJson(v.receiver_mobile_number)
              ],
              [
                "fs_info",
                fs_info_encode(v.fs_info)
              ],
              [
                "waypoints_attributes",
                Decco.arrayToJson(waypoints_attributes_encode, v.waypoints_attributes)
              ],
              [
                "value_added_services",
                Decco.arrayToJson(Decco.stringToJson, v.value_added_services)
              ],
              [
                "business_order_info",
                Decco.optionToJson(Decco.stringToJson, v.business_order_info)
              ],
              [
                "rebooking_info",
                Decco.optionToJson(rebooking_info_encode, v.rebooking_info)
              ],
              [
                "assign_manually",
                Decco.boolToJson(v.assign_manually)
              ]
            ]);
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "mobile",
                Decco.stringToJson(v.mobile)
              ],
              [
                "order",
                order_encode(v.order)
              ]
            ]);
}

export {
  fs_info_encode ,
  address_encode ,
  contact_encode ,
  address_details_encode ,
  rebooking_info_encode ,
  waypoints_attributes_encode ,
  goods_type_info_encode ,
  order_encode ,
  t_encode ,
  
}
/* No side effect */
